module.exports = __webpack_public_path__ + "dist/media/register-button.c148cdc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register-button.png
// module id = 390
// module chunks = 0